import { newRequest, oldRequest } from "./complexRequest"
import { ComplexRequestOption, ResponseType } from "./type"

export const uploadFile = (files: FileList | Blob | File, options: ComplexRequestOption = {}) => {
  const formData = new FormData
  if (files instanceof FileList)
    for (const file of files) {
      formData.append('file', file)
    }
  else {
    formData.append('file', files)
  }
  return oldRequest<ResponseType<any>>({
    ...options,
    url: '/Api/Upload/upload',
    method: 'post',
    transformRequest(data) {
      Object.keys(data).forEach(key => {
        formData.set(key, data[key])
      })
      return formData
    },
  }, false)
}

// upload Voice
export const uploadVoice = (files: FileList | Blob | File, options: ComplexRequestOption = {}) => {
  const formData = new FormData
  if (files instanceof FileList)
    for (const file of files) {
      formData.append('file', file)
    }
  else {
    formData.append('file', files)
  }
  return newRequest<ResponseType<any>>({
    ...options,
    url: 'client/voice/upload',
    method: 'post',
    transformRequest(data) {
      Object.keys(data).forEach(key => {
        formData.set(key, data[key])
      })
      return formData
    },
  }, false)
}



//  获取App配置
// NOTE: 必须走 fetch(useFetch=true)。axios 路径序列化的 queryString(空值带=、数组展开)
// 与签名串不一致，会被后端 CheckRequestID 拒绝(This request has expired)。
/** 按 group/key 查询 app_config GET /client/config/memo */
export const getAppConfigMemo = async (
  params: { group: string; key?: string; lang?: boolean },
  option?: ComplexRequestOption,
  useFetch = true,
) => {
  return newRequest<ResponseType<Record<string, string | number | boolean> | null>>({
    url: "/client/config/memo",
    method: "get",
    params,
    ...option,
  }, useFetch)
}

export const getAppConfig = async (
  option?: ComplexRequestOption,
  useFetch = true) => {
  return newRequest<ResponseType<any>>({
    url: '/client/config/app',
    method: 'get',
    ...option
  }, useFetch)
}

// webHome
// NOTE: 同 getAppConfig，必须走 fetch(useFetch=true)，axios 路径签名与后端校验不一致。
export const getWebHome = async (
  option?: ComplexRequestOption,
  useFetch = true) => {
  return newRequest<ResponseType<any>>({
    url: '/client/common/home/web-home',
    method: 'get',
    ...option
  }, useFetch)
}


